import { createAsyncThunk, createSlice, current } from '@reduxjs/toolkit';
import { getSecondaryOfferingData } from '../../services/secondaryOfferings/secondaryOfferingSection';
const initialState = {
  loading: true,
  loadingMore: false,
  sliderData: {},
  webData: {},
  mobileData: {},
};
export const fetchSecondaryOfferingListAction = createAsyncThunk('FETCH_SECONDARY_OFFERING_LIST', getSecondaryOfferingData);
export const fetchSecondartOfferingWebListAction = createAsyncThunk('FETCH_SECONDARY_OFFERING_WEB_LIST', getSecondaryOfferingData);
export const fetchSecondaryOfferingMobileListAction = createAsyncThunk('FETCH_SECONDARY_OFFERING_MOBILE_LIST', getSecondaryOfferingData);
export const fetchMoreSecondarySliderAction = createAsyncThunk('FETCH_MORE_SECONDARY_SLIDER', getSecondaryOfferingData);
export const fetchInfiniteSecondaryAction = createAsyncThunk('FETCH_INFINITE_SECONDARY', getSecondaryOfferingData);

export const secondaryOfferingSlice = createSlice({
  name: 'propertyDetails',
  initialState,
  reducers: {
    updateSecondaryPropertyList: (state, action) => {
      state.sliderData = {...action.payload};
    },
    updateWebSecondaryPropertyList: (state, action) => {
      state.webData = {...action.payload};
    },
    updateMobileSecondaryPropertyList: (state, action) => {
      state.mobileData = {...action.payload};
    }
  },
  extraReducers: {
    [fetchSecondaryOfferingListAction.pending]: (state, action) => {
      return {
        ...state,
        loading: true,
      };
    },
    [fetchSecondaryOfferingListAction.fulfilled]: (state, action) => {
      return {
        ...state,
        loading: false,
        sliderData: action.payload,
        webData: action.payload,
        mobileData: action.payload,
      };
    },
    [fetchSecondaryOfferingListAction.rejected]: (state, action) => {
      return {
        ...state,
        loading: false,
        data: {},
      };
    },

    //featching web initial page data
    [fetchSecondartOfferingWebListAction.pending]: (state, action) => {
      return {
        ...state,
        loading: true,
      };
    },
    [fetchSecondartOfferingWebListAction.fulfilled]: (state, action) => {
      return {
        ...state,
        loading: false,
        webData: action.payload,
      };
    },
    [fetchSecondartOfferingWebListAction.rejected]: (state, action) => {
      return {
        ...state,
        loading: false,
        data: {},
      };
    },

    //featching mobile data
    [fetchSecondaryOfferingMobileListAction.pending]: (state, action) => {
      return {
        ...state,
        loading: true,
      };
    },
    [fetchSecondaryOfferingMobileListAction.fulfilled]: (state, action) => {
      return {
        ...state,
        loading: false,
        mobileData: {
          ...current(state.mobileData),
          data: {
            ...current(state.mobileData.data),
            properties: current(state.mobileData.data.properties).concat(action.payload.data.properties),
          },
        },
      };
    },
    [fetchSecondaryOfferingMobileListAction.rejected]: (state, action) => {
      return {
        ...state,
        loading: false,
        data: {},
      };
    },

    [fetchInfiniteSecondaryAction.pending]: (state) => {
      return { ...state, loadingMore: true };
    },
    [fetchInfiniteSecondaryAction.rejected]: (state) => {
      return { ...state, loadingMore: false };
    },
    [fetchInfiniteSecondaryAction.fulfilled]: (state, action) => {
      return {
        ...state,
        loadingMore: false,
        webData: {
          ...current(state.webData),
          data: {
            ...current(state.webData.data),
            currentPage: action.payload.data.currentPage,
            properties: current(state.webData.data.properties).concat(action.payload.data.properties),
          },
        },
      };
    },

    [fetchMoreSecondarySliderAction.fulfilled]: (state, action) => {
      return {
        ...state,
        sliderData: {
          ...current(state.sliderData),
          data: {
            ...current(state.sliderData.data),
            properties: current(state.sliderData.data.properties).concat(action.payload.data.properties),
          },
        },
      };
    },
  },
});

export const { 
  updateSecondaryPropertyList,
  updateWebSecondaryPropertyList,
  updateMobileSecondaryPropertyList
} = secondaryOfferingSlice.actions;
const { reducer } = secondaryOfferingSlice;
export default reducer;
